import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAktualitasokEnabled } from '../hooks/useAktualitasokEnabled';
import AnnouncementsPage from './pages/AnnouncementsPage';

const AktualitasokPageRoute = () => {
  const { enabled, loading } = useAktualitasokEnabled();

  if (loading) {
    return null;
  }

  if (!enabled) {
    return <Navigate to="/informaciok" replace />;
  }

  return <AnnouncementsPage />;
};

export default AktualitasokPageRoute;
